
import api from '../../services/api'

export default () => new Promise((resolve, reject) =>
    api()({
        method: 'GET',

        url: '/webshop/tires-service/getTiresHistory'
    }).then(e => {
        resolve(e)
    }).catch(f => {
        reject(f)
    })
) 